// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"o9-z"};